import { render } from "./ServicePriceDialog.vue?vue&type=template&id=5be15688&scoped=true"
import script from "./ServicePriceDialog.vue?vue&type=script&lang=js"
export * from "./ServicePriceDialog.vue?vue&type=script&lang=js"

import "./ServicePriceDialog.vue?vue&type=style&index=0&id=5be15688&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be15688"]])

export default __exports__